export default __webpack_public_path__ + "static/media/Activate_UserGuide_internal.a2c43902.pdf";